import React, { FC } from "react"

import {
  IconFacebook,
  IconInstagram,
  IconLinkedIn,
  IconTwitter,
} from "components/core/Icons"
import { useResizedAvatarUrl } from "hooks/useResizedAvatarUrl"
import { Author } from "types"

import * as S from "./Header.styles"

interface AuthorHeaderProps {
  author: Author
}

export const Header: FC<AuthorHeaderProps> = ({ author }) => {
  const avatarUrl = author.avatar?.url
  const resizedAvatarUrl = useResizedAvatarUrl(avatarUrl, 110)

  const fullName = [author.firstName, author.lastName].join(" ")

  return (
    <S.Container>
      {resizedAvatarUrl && (
        <S.AuthorImg alt={fullName} src={resizedAvatarUrl} />
      )}
      <S.AuthorName>{fullName}</S.AuthorName>
      {author.description && (
        <S.Description>{author.description}</S.Description>
      )}
      <S.SocialMedia>
        {author.seo?.social?.twitter && (
          <S.LinkItem
            aria-label={`${fullName}'s Twitter`}
            href={`https://twitter.com/${author.seo?.social?.twitter}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <IconTwitter />
          </S.LinkItem>
        )}
        {author.seo?.social?.instagram && (
          <S.LinkItem
            aria-label={`${fullName}'s Instagram`}
            href={`https://www.instagram.com/${author.seo?.social?.instagram}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <IconInstagram />
          </S.LinkItem>
        )}
        {author.seo?.social?.facebook && (
          <S.LinkItem
            aria-label={`${fullName}'s Facebook`}
            href={author.seo?.social?.facebook}
            rel="noopener noreferrer"
            target="_blank"
          >
            <IconFacebook />
          </S.LinkItem>
        )}
        {author.seo?.social?.linkedIn && (
          <S.LinkItem
            aria-label={`${fullName}'s LinkedIn`}
            href={author.seo?.social?.linkedIn}
            rel="noopener noreferrer"
            target="_blank"
          >
            <IconLinkedIn />
          </S.LinkItem>
        )}
      </S.SocialMedia>
      <S.FollowText>
        Follow not to miss stories from {author.firstName}
      </S.FollowText>
    </S.Container>
  )
}
